// Contas conectadas > Como pagar os anúncios (/app/:companyId/contas/pagamento?plataforma=meta).
// Passo a passo para criar a conta de anúncios e a forma de pagamento na plataforma e depois conectar aqui.
import { Link, useSearchParams } from 'react-router-dom'
import { ExternalLink, Info, ShieldCheck } from 'lucide-react'
import { useCompany } from '../../lib/company'
import { Empty, PageHead, PlatformLogo } from '../../ui'
import { PAYMENT_GUIDES, paymentGuideFor } from '../../features/connections/paymentGuides'
import '../../features/tracking/tracking.css'

export default function PaymentGuide() {
  const company = useCompany()
  const [params, setParams] = useSearchParams()
  const requested = params.get('plataforma')
  // sem plataforma abre a Meta; plataforma sem guia não cai na Meta calada
  const guide = requested ? paymentGuideFor(requested) : PAYMENT_GUIDES[0]

  return (
    <div className="stack" style={{ gap: 20 }}>
      <PageHead title="Como pagar os anúncios" sub="Você paga direto à plataforma onde anuncia. Crie a conta de anúncios, cadastre a forma de pagamento lá e depois conecte aqui." />

      <div className="callout">
        <ShieldCheck size={18} color="var(--primary)" style={{ flexShrink: 0, marginTop: 2 }} />
        <span className="small">O dinheiro dos anúncios não passa pelo Seu Impulso. A plataforma cobra no seu cartão, Pix ou boleto; nós cobramos só a assinatura.</span>
      </div>

      <div className="platform-grid" role="radiogroup" aria-label="Plataforma">
        {PAYMENT_GUIDES.map((g) => (
          <button key={g.id} type="button" role="radio" aria-checked={guide?.id === g.id} className={`platform-opt ${guide?.id === g.id ? 'on' : ''}`} onClick={() => setParams({ plataforma: g.id }, { replace: true })}>
            <PlatformLogo platform={g.id} />
            <span>{g.name}</span>
          </button>
        ))}
      </div>

      {!guide ? (
        <Empty title="Ainda não temos o passo a passo dessa plataforma">Escolha uma das plataformas acima ou siga a ajuda oficial da própria plataforma para cadastrar a forma de pagamento.</Empty>
      ) : <>
      <section className="card stack" style={{ gap: 14 }}>
        <div className="row between wrap" style={{ gap: 8 }}>
          <h2>1. Crie a conta de anúncios</h2>
          <a className="btn sm" href={guide.startUrl} target="_blank" rel="noreferrer">Abrir {guide.name} <ExternalLink size={13} /></a>
        </div>
        <p className="small muted">Já tem conta de anúncios? Pule para o passo 2.</p>
        <ol className="steps-list">{guide.createSteps.map((s) => <li key={s}><span>{s}</span></li>)}</ol>
      </section>

      <section className="card stack" style={{ gap: 14 }}>
        <h2>2. Cadastre a forma de pagamento</h2>
        <ol className="steps-list">{guide.paymentSteps.map((s) => <li key={s}><span>{s}</span></li>)}</ol>
        {guide.tips.map((t) => <div key={t} className="callout small"><Info size={16} color="var(--primary)" style={{ flexShrink: 0, marginTop: 2 }} /><span>{t}</span></div>)}
        <a className="small strong row" style={{ gap: 4, color: 'var(--primary)' }} href={guide.helpUrl} target="_blank" rel="noreferrer">Ajuda oficial <ExternalLink size={13} /></a>
        <p className="small muted">Os nomes dos menus podem mudar um pouco conforme a versão da plataforma.</p>
      </section>
      </>}

      <section className="card stack" style={{ gap: 14 }}>
        <h2>3. Conecte aqui</h2>
        <p className="small muted">Em Contas conectadas, entre com a mesma conta que você usou na plataforma e escolha a conta de anúncios. A gente confere se o pagamento está em dia antes de publicar qualquer anúncio.</p>
        <Link className="btn primary" style={{ alignSelf: 'flex-start' }} to={`/app/${company.id}/contas`}>Ir para Contas conectadas</Link>
      </section>
    </div>
  )
}
